    <div class="profile-page bg-secondary">
      <main class="pt-4">
        <div class="container wow fadeIn">
          <!--Grid row-->
          <div class="row">
            <div class="table-responsive">
          <table class="table table-bordered table-striped ">
            <thead class="thead-dark">
            <tr>
              <th>Date</th>
              <th>Meter Number</th>
              <th>Item Name</th>
              <th>ZWD Value</th>
              <th>Amount (R)</th>
              <th>Status</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in replayDto">
              <td>{{new Date(item.updatedOn).toLocaleString()}}</td>
              <td>{{item.itemDescription}}</td>
              <td>{{item.itemName}}</td>
              <td>{{item.amountInSalesCurrency}}</th>
              <td>{{item.totalAmount}}</td>
              <td>Pending</td>
              <td>
                <base-button @click="confirmAction(item)">
                  Refresh
                </base-button>
              </td>
            </tr>
          </tbody>
          </table>
    <!--spinner-->
        <div class="vld-parent">
          <loading :active.sync="isLoading" 
          :can-cancel="false" 
          :is-full-page="true"></loading>
      </div>
    <!--spinner-->
          </div>
        </div>
          <!--Grid row-->
        </div>
      </main>
      <!--Main layout-->
    </div>